import { ModificationLoanForm } from '../../Interface/Response/Interest/ModificationLoanForm';

export enum ModificationLoanFormType {
    LoanFormsLoaded = 'LoanFormsLoaded',
}

export interface ModificationLoanFormsLoadedAction {
    type: ModificationLoanFormType.LoanFormsLoaded;
    loanForms: ModificationLoanForm[];
}

export const modificationLoanFormsLoaded = (loanForms: ModificationLoanForm[]): ModificationLoanFormsLoadedAction => ({
    type: ModificationLoanFormType.LoanFormsLoaded,
    loanForms,
});

export type ModificationLoanFormActionTypes = ModificationLoanFormsLoadedAction;
